import React, { useState, useContext } from 'react'
import ApiService from '../../services/ApiService'
import { FeedbackContext } from '../../contexts/FeedbackContext'
import { useNavigate } from 'react-router-dom'
import ModalContext from '../../contexts/ModalContext'
import { Container, FormDiv, HeaderText, InputDiv, Label, Input, ButtonCreate } from './style'

const CreateOrdenoCustomer = () => {
  const { setFeedback } = useContext(FeedbackContext)
  const { setModalActive } = useContext(ModalContext)
  const navigate = useNavigate()
  const [nameExists, setNameExists] = useState(false)
  const [formData, setFormData] = useState({
    companyName: '',
    segment: '',
    cnpj: ''
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setFormData({ ...formData, [name]: value })
  }

  const handleCreate = () => {
    ApiService.steelOrders.createTenant(formData)
      .then(response => {
        if (response.data) {
          setFeedback({
            isOpen: true,
            message: 'Cliente cadastrado com sucesso',
            statusOk: true
          })
          setModalActive(false)
        }
      })
      .catch(error => {
        if(error.response?.status === 409) {
          setNameExists(true)
          setFeedback({
            isOpen: true,
            message: 'Cliente já existe',
            statusOk: false
          })
        } else {
          setFeedback({
            isOpen: true,
            message: 'Erro ao cadastrar cliente',
            statusOk: false
          })
        }
      })
  }

  return (
    <Container>
      <FormDiv>
        <HeaderText>Cadastrar cliente Ordeno</HeaderText>
        <InputDiv>
          <Label>Empresa</Label>
          <Input value={formData.companyName} onChange={handleChange} name="companyName"/>
        </InputDiv>
        <InputDiv>
          <Label>Segmento</Label>
          <Input value={formData.segment} onChange={handleChange} name="segment"/>
        </InputDiv>
        <InputDiv>
          <Label>CNPJ</Label>
          <Input value={formData.cnpj} onChange={handleChange} name="cnpj"/>
        </InputDiv>
        {nameExists && (
          <div style={{color: 'red', marginTop: '0.5rem'}}>
            Cliente já existe no sistema
          </div>
        )}
      </FormDiv>
      <ButtonCreate onClick={handleCreate}>Criar</ButtonCreate>
    </Container>
  )
}

export default CreateOrdenoCustomer